(() => {

    class DeviceElevatorModal {

        constructor() {

            this.modal = document.querySelector(
                "[data-device-destruction-elevator-modal]"
            );

            if (!this.modal) return;

            this.overlay =
                this.modal.querySelector(
                    "[data-modal-close]"
                );

            this.checkbox =
                this.modal.querySelector(
                    "[data-elevator-agree]"
                );

            this.confirmButton =
                this.modal.querySelector(
                    "[data-elevator-confirm]"
                );

            this.cancelButton =
                this.modal.querySelector(
                    "[data-elevator-cancel]"
                );

                        window.deviceBooking.elevator.productId =
            this.modal.dataset.elevatorProductId;

            window.deviceBooking.elevator.variantId =
                this.modal.dataset.elevatorVariantId;

            window.deviceBooking.elevator.displayPrice =
                this.modal.dataset.elevatorPrice;

            window.deviceBooking.elevator.rawPrice =
                Number(this.modal.dataset.elevatorPriceRaw);

            window.deviceBooking.elevator.title =
                this.modal.dataset.elevatorTitle;

            this.bindEvents();

        }

        open() {

            this.modal.hidden = false;

            document.body.classList.add(
                "overflow-hidden"
            );

        }

        close() {

            this.modal.hidden = true;

            document.body.classList.remove(
                "overflow-hidden"
            );

            this.checkbox.checked = false;

            this.confirmButton.disabled = true;

        }

        bindEvents() {

            this.overlay.addEventListener(
                "click",
                () => this.close()
            );

            this.cancelButton.addEventListener(
                "click",
                () => this.close()
            );

            this.checkbox.addEventListener(
                "change",
                () => {

                    this.confirmButton.disabled =
                        !this.checkbox.checked;

                }
            );

           this.confirmButton.addEventListener(
                "click",
                () => {

                    const liftAccess = (
                        document.querySelector(
                            '[name="properties[Lift Access]"]'
                        )?.value || ""
                    ).trim();

                    window.deviceBooking.elevator.required =
                        liftAccess.toLowerCase() === "no";

                    console.log("Lift Access:", liftAccess);
                    console.log("Comparison:", liftAccess === "No");

                    window.deviceBooking.elevator.confirmed = true;

                    window.deviceBooking.elevator.required =
                        liftAccess === "No";

                    this.close();

                    window.DeviceBookingProgress.showStep(4);

                }
            );

        }

    }

    document.addEventListener(

        "DOMContentLoaded",

        () => {

            window.DeviceElevatorModal =
                new DeviceElevatorModal();

        }

    );

})();